export var signalLevelTools = {

    data: function () {

    },

    methods: {

        getIconByValue(value) {

            const iconsList = [
                {v: "0:1000", icon: "mdi-wifi-strength-off-outline"},
                {v: "-70:-1", icon: "mdi-wifi-strength-4"},
                {v: "-84:-71", icon: "mdi-wifi-strength-3"},
                {v: "-100:-85", icon: "mdi-wifi-strength-2"},
                {v: "-109:-101", icon: "mdi-wifi-strength-1"},
                {v: "-200:-110", icon: "mdi-wifi-strength-off-outline"}
            ];

            value = parseInt(value);

            if (isNaN(value)) {
                return "mdi-alert";
            }

            const icons = iconsList.filter((iconI) => {
                const minMax = iconI.v.split(":");
                const min = parseInt(minMax[0]);
                const max = parseInt(minMax[1]);
                return (value >= min && value <= max);
            });

            if (icons[0] && icons.length !== 1) {
                alert("Houve um erro ao interpretar nível de sinal, "
                        + " por favor, comunique o desenvolvedor: "
                        + "(" + value + ") "
                        + JSON.stringify(icons));
            }

            return (icons[0]) ? icons[0].icon : "mdi-wifi-strength-alert-outline";
        }
    }
};